import React from 'react';
import LeftBar from '../../Components/LeftBar';
import Dashnav from '../../Components/Dashnav';
import PaySalariesComp from './PaySalariesComp';

function PaySalaries({ cashOnly = false }) {
  return (
    <div className="mainContainer">
      <LeftBar />
      <div className="theMainContainer">
        <Dashnav />
        <PaySalariesComp cashOnly={cashOnly} />
      </div>
    </div>
  );
}

export default PaySalaries;
